import { tv } from 'tailwind-variants';

const PaperContainer = tv({
  base: 'p-4 rounded-4',
  variants: {
    cols: {
      single: 'columns-1',
      split: 'columns-2',
      three: 'columns-3',
    },
  },
});

const ExerciseText = tv({
  base: 'text-mono-900 [&>p__img]:mx-auto [&>p__img]:my-2',
  variants: {
    size: {
      default: 'text-sm',
      small: 'text-xs',
    },
  },
});

const AnswerOpts = tv({
  base: 'block relative float-none text-mono-900 [&>p]:flex [&>p]:flex-row [&>p]:items-center',
  variants: {
    size: {
      default: 'text-sm',
      small: 'text-xs',
    },
  },
});

const IconContainer = tv({
  base: 'w-fit px-2 py-1 rounded-t-md',
  variants: {
    color: {
      'anatomia-superior': 'bg-[#8B0000]',
      'bioquimica-superior': 'bg-[#FF5900]',
      'embriologia-superior': 'bg-[#4CAF50]',
      'farmacologia-superior': 'bg-[#6A1B9A]',
      'fisiologia-superior': 'bg-[#2196F3]',
      'genetica-superior': 'bg-[#00BCD4]',
      'histologia-superior': 'bg-[#607D8B]',
      'histologia-humana-superior': 'bg-[#607D8B]',
      'imunologia-superior': 'bg-[#FFD700]',
      'microbiologia-superior': 'bg-[#9CCC65]',
      'parasitologia-superior': 'bg-[#795548]',
      'patologia-superior': 'bg-[#B71C1C]',
    },
  },
});

const InfoLine = tv({
  base: 'w-full py-3 px-5 flex flex-row items-center justify-between',
  variants: {
    color: {
      'anatomia-superior': 'bg-[#8B0000]',
      'bioquimica-superior': 'bg-[#FF5900]',
      'embriologia-superior': 'bg-[#4CAF50]',
      'farmacologia-superior': 'bg-[#6A1B9A]',
      'fisiologia-superior': 'bg-[#2196F3]',
      'genetica-superior': 'bg-[#00BCD4]',
      'histologia-superior': 'bg-[#607D8B]',
      'histologia-humana-superior': 'bg-[#607D8B]',
      'imunologia-superior': 'bg-[#FFD700]',
      'microbiologia-superior': 'bg-[#9CCC65]',
      'parasitologia-superior': 'bg-[#795548]',
      'patologia-superior': 'bg-[#B71C1C]',
    },
  },
});

export { AnswerOpts, ExerciseText, IconContainer, InfoLine, PaperContainer };
